import { Patient, PatientAppointment } from "@/domain/entities";
import { PatientMapper } from "@/domain/mappers";
import { PatientRepository } from "@/domain/repositories";
import { PatientDataSource } from "../datasources/patients";
import {
  PatientDetailsResponse,
  PatientDetailsResponseAppointments,
  PatientsResponseAppointment,
} from "../dtos/responses";

export class PatientRepoImpl implements PatientRepository {
  constructor(
    private readonly dataSource: PatientDataSource,
    private readonly patientMapper: PatientMapper<
      PatientDetailsResponse,
      PatientsResponseAppointment,
      PatientDetailsResponseAppointments
    >,
  ) {}

  async getPatients(): Promise<PatientAppointment> {
    const data = await this.dataSource.getPatients();

    return {
      single: data.single.map((single) =>
        this.patientMapper.toPatientSingleAppointment(single),
      ),
      recurrent: data.recurrent.map((recurrent) =>
        this.patientMapper.toPatientRecurrentAppointment(recurrent),
      ),
    };
  }

  async getPatientById(id: number): Promise<Patient> {
    const data = await this.dataSource.getPatientById(id);
    return this.patientMapper.toDomain(data);
  }
}
